module.exports = __webpack_public_path__ + "static/img/6-1-1.f4c455c7.jpg";